module.exports = __webpack_public_path__ + "img/logo.b616a4e9.svg";